const removeUndef = (obj) =>
  Object.entries(obj)
    .filter(([key, value]) => value !== undefined)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export default function useTableView(viewKey) {
  const views = async () => JSON.parse(localStorage.getItem(viewKey));

  return {
    list: async () => views(),
    save: async (key, value) =>
      localStorage.setItem(viewKey, JSON.stringify({ ...(await views()), [key]: value })),
    remove: async (key) =>
      localStorage.setItem(
        viewKey,
        JSON.stringify(removeUndef({ ...(await views()), [key]: undefined })),
      ),
    get: (key) => views()[key],
  };
}
